import Cookie from './lib/cookie'
import Utils from './lib/utils'
import Storage from './lib/storage'

export default {
    Cookie,
    Utils,
    Storage
}

export {
    Cookie,Utils,Storage
}